import { z } from 'zod';
import { isoDateSchema, objectIdSchema, pageSchema } from './common.js';
/**
 * Journey feedback — artboards 9a and 9b, shown once after the trophy (5a) for a journey
 * the user has not given feedback on.
 *
 * Two answers, both on one screen: how the journey made them FEEL (one of five moods) and
 * a star rating for the app. That is deliberately lighter than the six-screen flow in
 * CLAUDE.md §5 — the design moved on 2026-10-18 — but the rules are the same: once per
 * journey, and Skip is always there (§2.7, feedback never blocks). The optional comment is
 * carried for the day the design adds its box; the app sends none today.
 */
export const FEEDBACK_MOODS = [
    { key: 'CALMER', label: 'Calmer', emoji: '😌' },
    { key: 'HOPEFUL', label: 'Hopeful', emoji: '🌱' },
    { key: 'STRONGER', label: 'Stronger', emoji: '💪' },
    { key: 'INSPIRED', label: 'Inspired', emoji: '✨' },
    { key: 'SAME', label: 'Not much', emoji: '😐' },
];
export const feedbackMoodSchema = z.enum(['CALMER', 'HOPEFUL', 'STRONGER', 'INSPIRED', 'SAME']);
/** What the star row says under itself, by rating. Index 0 is "nothing chosen yet". */
export const FEEDBACK_STAR_LABELS = [
    'Tap a star',
    'Not for me',
    'Could be better',
    'Good',
    'Really good',
    'Loved it',
];
export const submitFeedbackBodySchema = z.object({
    mood: feedbackMoodSchema,
    rating: z.number().int().min(1).max(5),
    comment: z.string().trim().max(500).optional(),
});
export const feedbackResponseSchema = z.object({
    id: objectIdSchema,
    journeyId: objectIdSchema,
    mood: feedbackMoodSchema,
    rating: z.number().int(),
    comment: z.string().nullable(),
    createdAt: isoDateSchema,
});
/* ───────────────────────── portal ───────────────────────── */
/** One row in the portal's inbox: who, which journey, what they said, when. */
export const adminFeedbackResponseSchema = feedbackResponseSchema.extend({
    journeyTitle: z.string(),
    userId: objectIdSchema,
    userName: z.string().nullable(),
    userMobile: z.string(),
});
export const listFeedbackQuerySchema = z.object({
    cursor: z.string().min(1).optional(),
    limit: z.coerce.number().int().min(1).max(50).default(20),
    journeyId: objectIdSchema.optional(),
    rating: z.coerce.number().int().min(1).max(5).optional(),
});
export const feedbackPageSchema = pageSchema(adminFeedbackResponseSchema).extend({
    /** Across every entry, not just this page — the inbox shows them as a headline. */
    total: z.number().int(),
    averageRating: z.number().nullable(),
});
//# sourceMappingURL=feedback.js.map